exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv#rest-select[data-v-186804f8] {\n  padding: 40px;\n}\ndiv#rest-select h1[data-v-186804f8] {\n    font-size: 32px;\n    text-align: center;\n}\n", "", {"version":3,"sources":["/codebuild/output/src561637037/src/src/components/RestaurantSelectPage.vue"],"names":[],"mappings":";AAoBA;EACE,cAAa;CAKd;AAND;IAGI,gBAAe;IACf,mBAAkB;CACnB","file":"RestaurantSelectPage.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\ndiv#rest-select {\n  padding: 40px; \n  h1 {\n    font-size: 32px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-186804f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RestaurantSelectPage.vue
// module id = 1UTE
// module chunks = 1